module.exports = __webpack_public_path__ + "static/media/AboutAlAin–Arabic@2x.2d34ef6d.jpg";